<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content>
    <form [formGroup]="form" autocomplete="off" class="container">
        <mat-form-field appearance="outline" autocomplete="off" class="form-field">
            <mat-label>New email</mat-label>
            <input type="text" autoComplete="off" matInput formControlName="email">
        </mat-form-field>
        <div *ngIf="errors.length > 0" class="validation-status">
            <p *ngFor="let error of errors">{{error}}</p>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button class="color" (click)="cancel()">{{button1}}</button>
    <span class="spacer"></span>
    <button mat-button class="color" (click)="overrideEmail()" cdkFocusInitial>{{button2}}</button>
</mat-dialog-actions>